import { Injectable } from '@angular/core';
import { IsoDate } from '../types/iso-date';
import { AbstractDateService } from './abstract-date.service';
import { isIsoDate } from '../functions/validation/is-iso-date.function';
import { toIsoDate } from '../functions/manupulation/conversion/to-iso-date.function';

@Injectable({providedIn: 'root'})
export class DateService extends AbstractDateService<IsoDate> {
  override now(): IsoDate {
    const now = new Date();
    return toIsoDate(now);
  }

  override isValid(date: string): date is IsoDate {
    return isIsoDate(date);
  }
}
